export const GOAL_CARD_SUCCESS_MESSAGE = 'Goal added successfully.';
export const enum GoalsActions {
    ADD = 'Add new Goal',
    EDIT = 'Edit Goal',
    DEFER = 'Defer Goal',
    CANCEL = 'Cancel Goal',
    START = 'Start Progress',
    COMPLETE = 'Complete Goal',
}